import moment from 'moment';
import 'moment-timezone';

const hoursDiv = document.querySelectorAll('.hour');

if (hoursDiv) {
	setInterval(() => {
		let now = moment();
		let second = now.second();
		
		hoursDiv.forEach((el) => {
			el.innerHTML = now.tz(el.getAttribute('data-tz')).format(second % 2 ? 'HH:mm' : 'HH mm');
		});
	}, 1000);
}